module.exports = __webpack_public_path__ + "img/login-logistic.d743d9e0.svg";